/**
 * Improve the general accessibility
 */
export const a11y = () => {
  /**
   * The prefers-reduced-motion media query detects whether the user has requested the operating system to minimize the amount of animation or motion it uses.
   * @see {@link https://web.dev/articles/prefers-reduced-motion?hl=en}
   */
  const handleReducedMotion = () => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = () => {
      const isReduced = mediaQuery.matches;

      if (isReduced) {
        /** Pause autoplay videos */
        const videos: HTMLVideoElement[] = Array.from(
          document.querySelectorAll('video[autoplay]')
        );

        videos.forEach((x) => {
          x.pause();
        });
      }
    };

    /** Listen for reduced motion settings changed on device */
    mediaQuery.addEventListener('change', update.bind(this));

    update();
  };

  handleReducedMotion();
};
